import { useLocation } from "react-router-dom";
import { useCategorizedEvents } from "../../hooks/useCategorizedEvents";
import EventItem from "../../components/Event/EventItem";
import Footer from "../../components/Layout/Footer";
import Navbar from "../../components/Layout/Navbar";

function Events() {
  const location = useLocation();
  const isMeetingPage = location.pathname.startsWith("/meetings");

  // Use the hook to get categorized and sorted events
  const categoryId = isMeetingPage ? 2 : 1;
  const linkPrefix = isMeetingPage ? "meetings" : "events";
  const { data: sortedEvents, loading } = useCategorizedEvents(categoryId, linkPrefix);

  return (
    <>
      <Navbar />

      <div className="container mx-auto px-20">
        <div className="mt-6 mb-6">
          <h2 className="text-2xl font-semibold mb-8">
            {isMeetingPage ? "Meetings" : "Events"}
          </h2>

          {loading ? (
            <p className="text-gray-500">
              Loading {isMeetingPage ? "meetings" : "events"}...
            </p>
          ) : sortedEvents.length > 0 ? (
            <div className="py-8">
              {sortedEvents.map((ev, idx) => {
                const currentYear = ev.year;
                const prevYear = idx > 0 ? sortedEvents[idx - 1].year : null;
                const showYear = idx === 0 || currentYear !== prevYear;

                return (
                  <EventItem
                    key={ev.id}
                    {...ev}
                    showYear={showYear}
                    isLast={
                      idx === sortedEvents.length - 1 ||
                      sortedEvents[idx + 1].year !== currentYear
                    }
                  />
                );
              })}
            </div>
          ) : (
            <p className="text-gray-500">No {isMeetingPage ? "meetings" : "events"} found.</p>
          )}
        </div>
      </div>

      <Footer />
    </>
  );
}

export default Events;
